import React, { useCallback, useContext, useState } from 'react';
import PrintIcon from '@material-ui/icons/Print';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { Loader, usePrintDispatch } from '@mummssoftware/common-ui';
import { AppContext } from '../../App/AppContext';

const PrintMedicationButton = (props) => {
  const { medication } = props;

  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const { patient, observation, agency, printingService } = useContext(
    AppContext,
  );

  const fetchLinkedNotes = () =>
    observation.getProgressNotesByEntity(
      patient.patientNumber,
      agency,
      'MMD',
      medication.id,
    );

  const getPrintPromise = useCallback(
    (faxInstructions, emailInstructions) =>
      fetchLinkedNotes().then((medOrders) =>
        printingService.printMedications(
          [medication],
          patient,
          { [medication.externalid]: medOrders },
          true,
          true,
          faxInstructions,
          emailInstructions,
        ),
      ),
    [printingService, medication, patient, observation, agency],
  );

  const { print, fax, email } = usePrintDispatch(
    getPrintPromise,
    () => {
      setAnchorEl(null);
      setLoading(true);
    },
    () => setLoading(false),
  );

  return (
    <>
      {loading && <Loader />}
      <IconButton
        aria-label="print row"
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <PrintIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={print}>Print</MenuItem>
        <MenuItem onClick={fax}>Fax</MenuItem>
        <MenuItem onClick={email}>Email</MenuItem>
      </Menu>
    </>
  );
};

export default PrintMedicationButton;
